import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { GlossaryList } from '../components/glossary/glossary-list/GlossaryList';
import { GlossaryNavigation } from '../components/glossary/glossary-navigation/GlossaryNavigation';
const GlossaryContainer = ({ glossaryGrouped }) => {
    const [activeGlossaries, setActiveGlossaries] = useState(glossaryGrouped);
    const [activeGlossaryItem, setActiveGlossaryItem] = useState();
    const handleClick = (filterKey) => {
        setActiveGlossaryItem(filterKey);
        setActiveGlossaries({ [filterKey]: glossaryGrouped[filterKey] });
    };
    const showAll = () => {
        setActiveGlossaryItem(undefined);
        setActiveGlossaries(glossaryGrouped);
    };
    if (!glossaryGrouped) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [_jsx(GlossaryNavigation, { glossaries: glossaryGrouped, onClick: handleClick, showAll: showAll, activeGlossaryItem: activeGlossaryItem }), _jsx(GlossaryList, { glossaries: activeGlossaries })] }));
};
export default GlossaryContainer;
